import { lazy } from 'react'
const TemplateTitle = '%s - Shareplay - Bringing Communities to Sports | Bringing Fitness to Families | Reframing Sports in Schools'
const DefaultRoute = '/home'

const Routes = [
  {
    path: '/home',
    className: 'ecommerce-application',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/home')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/play',
    className: 'ecommerce-application',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/play')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/profile',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/profile'))
  },
  {
    path: '/profile/:id',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/profile'))
  },
  {
    path: '/bookings',
    component: lazy(() => import('@src/views/pages/bookings'))
  },
  {
    path: '/enrols',
    component: lazy(() => import('@src/views/pages/home/Enrols'))
  },
  {
    path: '/subs',
    component: lazy(() => import('@src/views/pages/home/Subscrs'))
  },
  {
    path: '/renewals',
    component: lazy(() => import('@src/views/pages/home/Renewals'))
  },
  {
    path: '/memberships',
    component: lazy(() => import('@src/views/pages/home/Memberships'))
  },
  {
    path: '/attends',
    component: lazy(() => import('@src/views/pages/home/Attends'))
  },
  {
    path: '/metrics',
    component: lazy(() => import('@src/views/pages/home/Metrics'))
  },
  {
    path: '/classes',
    component: lazy(() => import('@src/views/pages/home/Classes'))
  },
  {
    path: '/payments',
    component: lazy(() => import('@src/views/pages/home/Payments'))
  },
  {
    path: '/experience',
    component: lazy(() => import('@src/views/pages/experience'))
  },
  {
    path: '/coach',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/coach/Programs')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/coach/batches',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/coach/Batches'))
  },
  {
    path: '/batch',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/coach/Batch'))
  },
  {
    path: '/attendance',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/coach/Attendance'))
  },
  {
    path: '/batchinfo',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/coach/BatchInfo'))
  },
  {
    path: '/metrics-capture',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/coach/MetricsCapture'))
  },
  {
    path: '/renew',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/coach/RenewEnrol'))
  },
  {
    path: '/venue/dav',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/learn/DAV')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/program/:id',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/learn/ProgDetails')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/progEnrol',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/learn/ProgEnrol')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/enroll',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/learn/Enroll'))
  },
  {
    path: '/org/:id',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/learn/OrgView')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/intOrg/:id',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/learn/OrgView')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/pEn/:id',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/learn/PayEnrol')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/pBook/:id',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/bookings/PayBook')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/pSub/:id',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/learn/PaySubs')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/subattendance',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/coach/SubAttendance'))
  },
  {
    path: '/admin/booking-management',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/admin/booking-management'))
  },
  {
    path: '/admin/coaching-management',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/admin/coaching-management'))
  },
  {
    path: '/admin/member-management',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/admin/member-management'))
  },
  {
    path: '/admin/reports',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/admin/reports'))
  },
  {
    path: '/admin/org-management',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/admin/org-management'))
  },
  {
    path: '/admin/venue-management',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/admin/venue-management'))
  },
  {
    path: '/admin/shareplay-management',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/admin/shareplay-management'))
  },
  {
    path: '/login',
    component: lazy(() => import('@src/views/Login')),
    layout: 'BlankLayout',
    meta: { authRoute: true }
  },
  {
    path: '/signup',
    component: lazy(() => import('@src/views/Signup')),
    layout: 'BlankLayout',
    meta: { authRoute: true }
  },
  {
    path: '/addChild',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/pages/profile/AddChild')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/learn',
    component: lazy(() => import(/* webpackPrefetch: true */'@src/views/pages/learn')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/sport/:id',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/general/SportPage')),
    layout: 'BlankLayout',
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/venue/:id',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/general/Venue')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/notifs',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/general/Notifs'))
  },
  {
    path: '/venues/*',
    className: 'ecommerce-application',
    component: lazy(() => import('@src/views/general/Venues')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/aboutus',
    component: lazy(() => import('@src/views/general/AboutUs')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/explore',
    component: lazy(() => import('@src/views/general/Explore')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/contact',
    component: lazy(() => import('@src/views/general/ContactUs')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/terms',
    component: lazy(() => import('@src/views/general/Terms')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/privacy',
    component: lazy(() => import('@src/views/general/Privacy')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/refunds',
    component: lazy(() => import('@src/views/general/Refunds')),
    meta: { authRoute: false, publicRoute: true }
  },
  {
    path: '/error',
    component: lazy(() => import('@src/views/general/Error'))
  },
  {
    path: '/logout',
    component: lazy(() => import('@src/views/general/Logout')),
    layout: 'BlankLayout'
  }
]

export { DefaultRoute, TemplateTitle, Routes }
